import React, { useState, useEffect } from 'react'
import * as Yup from 'yup';
import CallBackForm from './CallBackForm';

export default function SideBarForm({page_name="Common Page", product_name=null , form_name="common-form",endpoint='/enquiry/open-create', slug=null}) {
  const [scrolled, setScrolled] = useState(0)
  const options = {
    btn_name: "Submit"
  }
  const phoneRegExp = /^(\+\d{1,4})?(\d{9,14})$/
  const fields = [
    {
        name: 'name',
        label: '',
        placeholder: 'Full Name*',
        validation: Yup.string().matches(/^[a-zA-Z\s]*$/, 'Name can only contain letters and spaces').required('Name is required'),
        customClass: 'col-span-12'
    },
    {
        name: 'email',
        type: 'email',
        label: '',
        placeholder: 'Add Your Company E-mail Address*',
        validation: Yup.string().email('Invalid email').required('Email is required'),
        customClass: 'col-span-12'
    
    },
    {
        name: 'company_name',
        label: '',
        placeholder: 'Company Name',
        customClass: 'col-span-12'
    },
    {
      name: 'phone',
      label: '',
      placeholder: 'Phone Number*',
      validation: Yup.string().matches(phoneRegExp, 'Phone number is not valid'),
      customClass: 'col-span-12'
    },
    {
        name: 'message',
        label: '',
        placeholder: 'Message',
        type: 'textarea',
        customClass: 'col-span-12',
        col_row:2
    },
  ];

  return (
      <>
        <div className="border rounded-lg shadow-md p-4">
          <CallBackForm 
            fields={fields}
            options={options}
            page_name={page_name}
            form_name={form_name}
            endpoint={endpoint}
            product_name={product_name}
            slug={slug}
          />
        </div>
      </>
  );
}
